<template>
  <div class="wrapper">
    <div class="search-bar">
      <div class="select-row">
        <div class="select-item">
          <select v-model="provinceCode" @change="onProvinceChange">
            <option value="">全部省</option>
            <option v-for="p in regionList" :key="p.code" :value="p.code">
              {{ p.name }}
            </option>
          </select>
        </div>
        <div class="select-item">
          <select
            v-model="cityCode"
            :disabled="!provinceCode"
            @change="onCityChange"
          >
            <option value="">全部市</option>
            <option v-for="c in cityList" :key="c.code" :value="c.code">
              {{ c.name }}
            </option>
          </select>
        </div>
      </div>
      <van-search
        v-model="name"
        class="keyword-search"
        placeholder="请输入门店名称"
        @search="handleSearch"
        @blur="handleSearch"
        @clear="handleSearch"
      />
      <van-search
        v-model="address"
        class="keyword-search"
        placeholder="请输入详细地址"
        @search="handleSearch"
        @blur="handleSearch"
        @clear="handleSearch"
      />
    </div>

    <div class="store-list-container">
      <div class="store-table">
        <table>
          <thead>
            <tr>
              <th>商品名称</th>
              <th>门店名称</th>
              <th>省</th>
              <th>市</th>
              <th>详细地址</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in storeList" :key="item.id">
              <td>{{ item.title || '—' }}</td>
              <td>{{ item.name || '—' }}</td>
              <td>{{ item.provinceName || '—' }}</td>
              <td>{{ item.cityName || '—' }}</td>
              <td>{{ item.address || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <van-empty
        v-if="!loading && storeList.length === 0"
        description="暂无数据"
      />
    </div>

    <!-- 分页 -->
    <div class="pagination" v-show="total > 0">
      <van-pagination
        v-model="currentPage"
        :total-items="total"
        :items-per-page="pageSize"
        :show-page-size="3"
        force-ellipses
        @change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { listStoreForH5, listRegionForH5 } from '@/api/taobaoFlashStore'

export default {
  name: 'TaobaoFlashStoreList',
  data() {
    return {
      itemId: this.$route.query.itemId || undefined,
      name: '',
      address: '',
      regionList: [],
      provinceCode: '',
      cityCode: '',
      storeList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    // 省市二级联动：选省后加载对应市列表
    cityList() {
      const province = this.regionList.find(
        item => item.code === this.provinceCode
      )
      return (province && province.children) || []
    },
    provinceName() {
      const province = this.regionList.find(
        item => item.code === this.provinceCode
      )
      return province ? province.name : ''
    },
    cityName() {
      const city = this.cityList.find(item => item.code === this.cityCode)
      return city ? city.name : ''
    }
  },
  created() {
    this.loadRegion()
  },
  mounted() {
    this.loadData()
  },
  methods: {
    // 省市二级列表
    async loadRegion() {
      try {
        const { data } = await listRegionForH5({})
        this.regionList = data || []
      } catch (error) {
        console.log(error)
      }
    },
    onProvinceChange() {
      this.cityCode = ''
      this.handleSearch()
    },
    onCityChange() {
      this.handleSearch()
    },
    async loadData() {
      try {
        this.loading = true
        const { data } = await listStoreForH5({
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          param: {
            itemId: this.itemId,
            provinceName: this.provinceName || undefined,
            cityName: this.cityName || undefined,
            name: this.name || undefined,
            address: this.address || undefined
          }
        })
        this.storeList = data.records || []
        this.total = data.total || 0
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    handlePageChange(page) {
      this.currentPage = page
      this.loadData()
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ecedf0;
  box-sizing: border-box;
  overflow: hidden;
}

.search-bar {
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  margin: 10px;
  padding: 10px 10px 0;
  box-sizing: border-box;
}

.select-row {
  display: flex;
  gap: 10px;
}

.select-item {
  flex: 1;
  min-width: 0;

  select {
    width: 100%;
    height: 34px;
    box-sizing: border-box;
    padding: 0 24px 0 10px;
    font-size: 14px;
    color: #333;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff
      url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23999'/%3E%3C/svg%3E")
      no-repeat right 8px center;
    appearance: none;
    -webkit-appearance: none;
    outline: none;

    &:disabled {
      color: #c0c4cc;
      background-color: #f5f7fa;
    }
  }
}

.keyword-search {
  padding: 6px 0 6px;
}

.store-list-container {
  flex: 1;
  min-height: 0;
  margin-top: 4px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.store-table {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin: 8px;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }

  th,
  td {
    padding: 8px 10px;
    border: 1px solid #f0f0f0;
    text-align: left;
    word-break: break-all;
  }

  th {
    background: #f5f7fa;
    color: #333;
    font-weight: 500;
    white-space: nowrap;
  }

  td {
    color: #666;
  }
}

.pagination {
  flex-shrink: 0;
  padding: 12px;
  box-sizing: border-box;
  color: #666;
  font-size: 14px;
}
</style>
